import api from './api';

const designerBonusService = {
  getSettings: () => api.get('/designer-bonus/settings'),
  saveSettings: (payload) => api.put('/designer-bonus/settings', payload),
  getAmazonSummary: (params) => api.get('/designer-bonus/sales/amazon-summary', { params }),
  getWebsiteSummary: (params) => api.get('/designer-bonus/sales/website-summary', { params }),
  aggregateEtsy: (payload) => api.post('/designer-bonus/sales/etsy/aggregate', payload),
  listSavedCalculations: (params) => api.get('/designer-bonus/saved-calculations', { params }),
  createSavedCalculation: (payload) => api.post('/designer-bonus/saved-calculations', payload),
  getSavedCalculation: (id) => api.get(`/designer-bonus/saved-calculations/${id}`),
  updateSavedCalculation: (id, payload) => api.put(`/designer-bonus/saved-calculations/${id}`, payload),
  submitSavedCalculation: (id) => api.post(`/designer-bonus/saved-calculations/${id}/submit`, {}),
  approveSavedCalculation: (id) => api.post(`/designer-bonus/saved-calculations/${id}/approve`, {}),
};

export default designerBonusService;
